import { useEffect, useState } from "react";
import {
  encouragementString,
  LightBlue,
  LightDarkGray,
  passageString,
  titleString,
} from "../../../constants";
import { getDisplayVerse } from "../../../helpers/bible";
import { getSermonTitle, getSpeaker } from "../../../helpers/points";
import { useAppSelector } from "../../../app/hooks";
import { selectLanguage } from "../../../app/slices/languageSlice";

/**************************************************
 * STYLES
 **************************************************/
const sermonEntityStyle = {
  fontWeight: "500",
};

const speakerStyle = {
  fontWeight: "400",
};

const hoverStyle = {
  color: LightBlue,
  cursor: "pointer",
  paddingBottom: "10px",
  fontSize: "14px",
};

const mainStyle = {
  color: LightDarkGray,
  fontSize: "14px",
  paddingBottom: "10px",
};

const titleCaptionStyle = {
  fontSize: "14px",
  fontWeight: "400",
};

const titleStyle = {
  fontSize: "14px",
  fontWeight: "300",
  paddingTop: "0",
  alignSelf: "center",
  fontStyle: "italic",
};

const seriesCaptionStyle = {
  fontSize: "14px",
  fontWeight: "400",
};

const seriesTitleStyle = {
  fontSize: "14px",
  fontWeight: "300",
};

const EncouragementPoint = ({ servicePoint, handlePointTimestamp }) => {
  const language = useAppSelector(selectLanguage);
  const {
    SERMON_TITLE_EN,
    SERMON_TITLE_RO,
    PASSAGE,
    LOCATION_FROM,
    PERSON_TITLE,
    SPEAKER,
  } = servicePoint;
  const [encouragementPointStyle, setEncouragementPointStyle] =
    useState(mainStyle);
  const [speaker, setSpeaker] = useState(
    getSpeaker(PERSON_TITLE, SPEAKER, LOCATION_FROM, language)
  );
  const [sermonTitle, setSermonTitle] = useState(
    getSermonTitle(language, SERMON_TITLE_EN, SERMON_TITLE_RO)
  );
  const [displayVerse, setDisplayVerse] = useState(
    getDisplayVerse(language, PASSAGE)
  );

  useEffect(() => {
    setSpeaker(getSpeaker(PERSON_TITLE, SPEAKER, LOCATION_FROM, language));
    setSermonTitle(getSermonTitle(language, SERMON_TITLE_EN, SERMON_TITLE_RO));
    setDisplayVerse(getDisplayVerse(language, PASSAGE));
  }, [
    language,
    PERSON_TITLE,
    SPEAKER,
    LOCATION_FROM,
    SERMON_TITLE_EN,
    SERMON_TITLE_RO,
    PASSAGE,
  ]);

  const handleMouseEnter = () => {
    setEncouragementPointStyle(hoverStyle);
  };

  const handleMouseLeave = () => {
    setEncouragementPointStyle(mainStyle);
  };

  const hasPassage = () => {
    return PASSAGE ? true : false;
  };

  const hasTitle = () => {
    return SERMON_TITLE_EN || SERMON_TITLE_RO;
  };

  const handleClick = () => {
    handlePointTimestamp(servicePoint.START_TIMESTAMP_UNIX);
  };

  return (
    <div
      style={encouragementPointStyle}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onClick={handleClick}
    >
      <div>
        <span style={sermonEntityStyle}>
          {encouragementString(language)}
          {speaker && ": "}
        </span>
        <span style={speakerStyle}>{speaker}</span>
      </div>
      <div>
        {hasTitle() && (
          <span style={titleCaptionStyle}>{titleString(language)}: </span>
        )}
        {hasTitle() && <span style={titleStyle}>"{sermonTitle}"</span>}
      </div>
      <div>
        {hasPassage() && (
          <span style={seriesCaptionStyle}>{passageString(language)}: </span>
        )}
        {hasPassage() && <span style={seriesTitleStyle}>{displayVerse}</span>}
      </div>
    </div>
  );
};

export default EncouragementPoint;
